import { createSlice } from '@reduxjs/toolkit';
import {
  getActivities,
  getCompanies,
  getComments,
  getFiles,
  getOperations,
  getSteps,
  getOperationUpdate,
  getContainersOperation,
  createComment,
  createContainerComment,
  createOperation,
  getStep,
  getUsers,
  getExternalUsers,
  getBusinesslines,
  getRoles,
  getAnalysts,
  getAllCompanies,
  fetchUpdateOperation,
  getFilesContainer,
  fetchQuickSightUrl,
  getEmails,
} from '../actions/generalActions';

const initialState = {
  isLoading: false,
  operations: [],
  operation: {},
  companies: [],
  steps: [],
  step: {},
  operation_info: [],
  activities: [],
  containers: [],
  comments: [],
  users: [],
  externalUsers: [],
  businesslines: [],
  roles: [],
  analysts: [],
  allCompanies: [],
  quickSightUrl: null,
  files: '',
  error: null,
};

export const generalSlices = createSlice({
  name: 'general',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getOperations.fulfilled, (state, { payload }) => {
      state.operations = [...payload.operations, ...payload.operations_draft];
      state.companies = payload.companies;
      state.isLoading = false;
    });
    builder.addCase(getOperations.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOperations.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getCompanies.fulfilled, (state, { payload }) => {
      state.companies = payload.companies;
      state.isLoading = false;
    });
    builder.addCase(getCompanies.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCompanies.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getSteps.fulfilled, (state, { payload }) => {
      state.steps = payload.steps;
      state.operation_info = payload.operation_info;
      state.isLoading = false;
    });
    builder.addCase(getSteps.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSteps.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getStep.fulfilled, (state, { payload }) => {
      state.step = payload.step;
      state.isLoading = false;
    });
    builder.addCase(getStep.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getStep.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getActivities.fulfilled, (state, { payload }) => {
      state.activities = payload.activities;
      state.isLoading = false;
    });
    builder.addCase(getActivities.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getActivities.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getEmails.fulfilled, (state, { payload }) => {
      state.emails = payload.emails;
      state.isLoading = false;
    });
    builder.addCase(getEmails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getEmails.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getContainersOperation.fulfilled, (state, { payload }) => {
      state.containers = payload.containers;
      state.isLoading = false;
    });
    builder.addCase(getContainersOperation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getContainersOperation.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getComments.fulfilled, (state, { payload }) => {
      state.comments = payload.comments;
      state.isLoading = false;
    });
    builder.addCase(getComments.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getComments.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getFiles.fulfilled, (state, { payload }) => {
      state.files = payload.files;
      state.isLoading = false;
    });
    builder.addCase(getFiles.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getFiles.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getFilesContainer.fulfilled, (state, { payload }) => {
      state.files = payload.files;
      state.isLoading = false;
    });
    builder.addCase(getFilesContainer.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getFilesContainer.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getOperationUpdate.fulfilled, (state, { payload }) => {
      state.operation = payload;
      state.isLoading = false;
    });
    builder.addCase(getOperationUpdate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOperationUpdate.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createComment.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createComment.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createComment.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createContainerComment.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createContainerComment.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createContainerComment.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createOperation.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(createOperation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createOperation.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(fetchUpdateOperation.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(fetchUpdateOperation.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUpdateOperation.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getUsers.fulfilled, (state, { payload }) => {
      state.users = payload.users;
      state.isLoading = false;
    });
    builder.addCase(getUsers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUsers.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getExternalUsers.fulfilled, (state, { payload }) => {
      state.externalUsers = payload.users;
      state.isLoading = false;
    });
    builder.addCase(getExternalUsers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getExternalUsers.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getBusinesslines.fulfilled, (state, { payload }) => {
      state.businesslines = payload.businesslines;
      state.isLoading = false;
    });
    builder.addCase(getBusinesslines.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBusinesslines.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getRoles.fulfilled, (state, { payload }) => {
      state.roles = payload.roles;
      state.isLoading = false;
    });
    builder.addCase(getRoles.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getRoles.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getAnalysts.fulfilled, (state, { payload }) => {
      state.analysts = payload.analysts;
      state.isLoading = false;
    });
    builder.addCase(getAnalysts.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAnalysts.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getAllCompanies.fulfilled, (state, { payload }) => {
      state.allCompanies = payload.companies;
      state.isLoading = false;
    });
    builder.addCase(getAllCompanies.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAllCompanies.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(fetchQuickSightUrl.fulfilled, (state, { payload }) => {
      state.quickSightUrl = payload.url;
      state.isLoading = false;
    });
    builder.addCase(fetchQuickSightUrl.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchQuickSightUrl.rejected, (state) => {
      state.isLoading = false;
    });
  },
  reducers: {
    onRestartStateGeneral: (state) => {
      state.isLoading = false;
      state.operations = [];
      state.companies = [];
      operation_info = [];
      state.steps = [];
      state.step = {};
      state.activities = [];
      state.containers = [];
      state.comments = [];
      state.users = [];
      state.externalUsers = [];
      state.businesslines = [];
      state.roles = [];
      state.files = [];
      state.error = null;
    },
    onRestartActivities: (state) => {
      state.activities = [];
    },
  },
});

export const { onRestartStateGeneral, onRestartActivities } = generalSlices.actions;
